import React, { Component } from "react";
import clsx from 'clsx';
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { connect } from 'react-redux';
import HeaderMenu from "../../components/header-menu";
import { Grid, Card, CardContent, Button, IconButton, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import BoltIcon from '@mui/icons-material/Bolt';
import VerifiedIcon from '@mui/icons-material/Verified';
import ReplayIcon from '@mui/icons-material/Replay';
import Api from "../../services/api";
import ApiReports from "../../services/apireport";
import CustomizedSnackbars from "../../components/material-snackbars";
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import * as calledsActions from '../../redux/actions/calleds';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleAutoCompleteSearch from '../../components/auto-complete/autocomplete-search-api';
import SimpleDatePicker from '../../components/date-pickers/inline-no-today';
import moment from 'moment';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getAllSelectionModel } from '../../services/techinicalteam.service';
import { getAllSelectionModelByTechnicalTeam } from '../../services/organization.service';
import { getAllUsersSelecionModelByRoleTypeAndOrganizationIdAndTechnicalTeamIdAndUserId } from '../../services/user.service';
import { getAllSelectionModel as getAllOriginRequestsSelectionModel } from '../../services/originrequest.service';
import { getAttendanceTimeDashboardData, getSolutionTimeDashboardData } from '../../services/calledstatus.service';
import * as AgentProductivityService from '../../services/agentproductivitydashboard.service';
import { evaluateSession } from '../../utils/sessionUtils';
import KpiCard from './components/kpi-card';
import TicketsByAgent from './components/tickets-by-agent';
import ChannelDonut from './components/channel-donut';
import CsatTable from './components/csat-table';
import NpsTable from './components/nps-table';
import PerformancePanel from './components/performance-panel';
import HourlyProductivityChart from './components/hourly-productivity-chart';
import DashboardSkeleton from './components/dashboard-skeleton';
import { getChartColors } from '../../utils/chartTheme';

const formatHoursLabel = hours => {
  const h = Math.floor(hours || 0);
  const m = Math.round(((hours || 0) - h) * 60);
  return `${h}h ${m}m`;
};

const aggregateTimeAverage = list => {
  if (!list || list.length === 0) return { hours: 0, label: '0h 0m' };
  const totalTime = list.reduce((sum, item) => sum + (item.totalattendancetime || item.totalsolutiontime || 0), 0);
  const totalCount = list.reduce((sum, item) => sum + (item.calledcount || 0), 0);
  const avgHours = totalCount > 0 ? totalTime / totalCount : 0;
  return { hours: avgHours, label: formatHoursLabel(avgHours) };
};

const buildDailySeries = list => (list || []).map(item => ({ date: item.date, count: item.count }));

const buildPercentSeries = list => (list || []).map(item => ({ date: item.date, count: item.percent }));

const formatPercent = (value, locale) => `${new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value || 0)}%`;

const defaultFilterValue = { id: 0, name: '' };

class AgentProductivityDashboard extends Component {

  constructor(props) {
    super(props);

    const { userSession } = this.props;
    evaluateSession(userSession);

    this.isClient = true;
    this.globalAdm = false;
    this.AdmOrganization = false;
    this.onlyAdmOrganization = false;
    this.isCoordenator = false;
    this.isTechinical = false;

    userSession.user.userrole.forEach((item) => {
      if (item.role.roletype != 3) this.isClient = false;
      if (item.role.roletype == 0) this.globalAdm = true;
      if (item.role.roletype == 1) this.AdmOrganization = true;
      if (item.role.roletype == 4) this.isCoordenator = true;
      if (item.role.roletype == 2) this.isTechinical = true;
    });
    if (this.AdmOrganization == true && this.globalAdm == false) {
      this.onlyAdmOrganization = true;
    }
    if (userSession.user.userrole == null) {
      Api.logoff();
    }

    this.state = {
      dateStart: new Date(),
      dateEnd: new Date(),

      technicalTeamList: [],
      technicalTeam: { ...defaultFilterValue },
      organizationsList: [],
      organization: { ...defaultFilterValue },
      userList: [],
      userListVersion: 0,
      user: { ...defaultFilterValue },
      originRequestList: [],
      originRequest: { ...defaultFilterValue },

      summary: { totalassigned: 0, totalresolved: 0, assigneddailyseries: [], resolveddailyseries: [], assignedtrend: [], resolvedtrend: [], fcrtrend: [], slatrend: [], reopenedtrend: [] },
      byAgent: [],
      byChannel: [],
      hourly: [],
      csatData: [],
      npsData: [],
      slaPercent: 0,
      fcrPercent: 0,
      reopenedCount: 0,
      performanceMetrics: [],

      loading: true,
      showButtonPdf: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: ""
    };

    this.changeValues = this.changeValues.bind(this);
    this.search = this.search.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.getPdf = this.getPdf.bind(this);
  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  notifyError(result) {
    const intl = this.props.intl;
    this.setState({
      openNotification: true,
      notificationVariant: "error",
      notificationMessage: result && result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
    });
    Api.kickoff(result);
  }

  async getAllSelectionModel() {
    const result = await getAllSelectionModel();
    if (result.success) {
      this.setState({ technicalTeamList: result.data });
    } else {
      this.notifyError(result);
    }
  }

  async getOrganizations(technicalTeam = '') {
    const result = await getAllSelectionModelByTechnicalTeam((technicalTeam == null || technicalTeam == '') ? 0 : technicalTeam);
    if (result.success) {
      this.setState({ organizationsList: result.data });
    } else {
      this.notifyError(result);
    }
  }

  // Mesmo padrão do dashboard de produtividade atual: SimpleAutoCompleteSearch usa "options" só
  // como valor inicial (useState não re-sincroniza em prop change), então precisamos forçar
  // remount via `key` (userListVersion) sempre que a lista recarrega — senão o combo fica preso
  // na lista (vazia) do primeiro render, e só a busca por digitação (urlapi) funcionaria.
  async getUsers(technicalTeam = '', organizationId = '') {
    const result = await getAllUsersSelecionModelByRoleTypeAndOrganizationIdAndTechnicalTeamIdAndUserId(2, (technicalTeam == null || technicalTeam == '') ? 0 : technicalTeam, (organizationId == null || organizationId == '') ? 0 : organizationId, 0);
    if (result.success) {
      this.setState(prevState => ({ userList: result.data, userListVersion: prevState.userListVersion + 1 }));
    } else {
      this.notifyError(result);
    }
  }

  async getOriginRequests() {
    const result = await getAllOriginRequestsSelectionModel();
    if (result.success) {
      this.setState({ originRequestList: result.data });
    } else {
      this.notifyError(result);
    }
  }

  getPreviousPeriod(dateStart, dateEnd) {
    const start = moment(dateStart);
    const end = moment(dateEnd);
    const days = end.diff(start, 'days') + 1;
    const prevEnd = start.clone().subtract(1, 'days');
    const prevStart = prevEnd.clone().subtract(days - 1, 'days');
    return {
      prevStart: prevStart.format('YYYY-MM-DD 00:00:00'),
      prevEnd: prevEnd.format('YYYY-MM-DD 23:59:59')
    };
  }

  async loadItems(technicalTeamId = 0, organizationId = 0, userId = 0, originRequestId = 0) {
    const intl = this.props.intl;
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    const dateStartTime = moment(this.state.dateStart).format('YYYY-MM-DD 00:00:00');
    const dateEndTime = moment(this.state.dateEnd).format('YYYY-MM-DD 23:59:59');
    const { prevStart, prevEnd } = this.getPreviousPeriod(dateStart, dateEnd);

    await this.getOrganizations(technicalTeamId);
    await this.getUsers(technicalTeamId, organizationId);

    const [
      summaryResult,
      byAgentResult,
      byChannelResult,
      hourlyResult,
      attendanceTimeResult,
      solutionTimeResult,
      attendanceTimePrevResult,
      solutionTimePrevResult,
    ] = await Promise.all([
      AgentProductivityService.getSummary(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getByAgent(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getByChannel(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      AgentProductivityService.getHourly(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId),
      getAttendanceTimeDashboardData(dateStartTime, dateEndTime, organizationId, technicalTeamId, userId, originRequestId),
      getSolutionTimeDashboardData(dateStartTime, dateEndTime, organizationId, technicalTeamId, userId, originRequestId),
      getAttendanceTimeDashboardData(prevStart, prevEnd, organizationId, technicalTeamId, userId, originRequestId),
      getSolutionTimeDashboardData(prevStart, prevEnd, organizationId, technicalTeamId, userId, originRequestId),
    ]);

    if (summaryResult && summaryResult.success) {
      this.setState({ summary: summaryResult.data || this.state.summary });
    }
    if (byAgentResult && byAgentResult.success) {
      this.setState({ byAgent: byAgentResult.data || [] });
    }
    if (byChannelResult && byChannelResult.success) {
      this.setState({ byChannel: byChannelResult.data || [] });
    }
    if (hourlyResult && hourlyResult.success) {
      this.setState({ hourly: hourlyResult.data || [] });
    }

    const attendanceCurrent = aggregateTimeAverage(attendanceTimeResult && attendanceTimeResult.success ? attendanceTimeResult.data : []);
    const solutionCurrent = aggregateTimeAverage(solutionTimeResult && solutionTimeResult.success ? solutionTimeResult.data : []);
    const attendancePrevious = aggregateTimeAverage(attendanceTimePrevResult && attendanceTimePrevResult.success ? attendanceTimePrevResult.data : []);
    const solutionPrevious = aggregateTimeAverage(solutionTimePrevResult && solutionTimePrevResult.success ? solutionTimePrevResult.data : []);

    const percentChange = (current, previous) => {
      if (!previous) return null;
      return Math.round(((current - previous) / previous) * 100);
    };

    const tmrCurrent = attendanceCurrent.hours + solutionCurrent.hours;
    const tmrPrevious = attendancePrevious.hours + solutionPrevious.hours;

    // Linha com só 2 pontos (anterior -> atual): a mesma comparação usada pela seta/percentual,
    // pra garantir que a linha nunca contradiga a seta (baldes mensais dentro do período dão uma
    // tendência diferente da comparação período-atual-vs-anterior usada na seta).
    const attendanceSeries = [{ value: attendancePrevious.hours }, { value: attendanceCurrent.hours }];
    const solutionSeries = [{ value: solutionPrevious.hours }, { value: solutionCurrent.hours }];
    const tmrSeries = [{ value: tmrPrevious }, { value: tmrCurrent }];

    this.setState({
      performanceMetrics: [
        {
          label: intl.formatMessage({ id: 'agentproductivity.dashboard.performance.tme', defaultMessage: 'Tempo médio de espera (TME)' }),
          value: attendanceCurrent.label,
          comparation: percentChange(attendanceCurrent.hours, attendancePrevious.hours),
          series: attendanceSeries
        },
        {
          label: intl.formatMessage({ id: 'agentproductivity.dashboard.performance.tma', defaultMessage: 'Tempo médio de atendimento (TMA)' }),
          value: solutionCurrent.label,
          comparation: percentChange(solutionCurrent.hours, solutionPrevious.hours),
          series: solutionSeries
        },
        {
          label: intl.formatMessage({ id: 'agentproductivity.dashboard.performance.tmr', defaultMessage: 'Tempo médio de resolução (TMR)' }),
          value: formatHoursLabel(tmrCurrent),
          comparation: percentChange(tmrCurrent, tmrPrevious),
          series: tmrSeries
        },
      ]
    });

    await this.getMontlySla(dateStartTime, dateEndTime, organizationId, technicalTeamId, userId, originRequestId);
    await this.getCsat(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    await this.getNps(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    await this.getFcr(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    await this.getReopenedCount(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);

    this.setState({ showButtonPdf: true });
  }

  async getMontlySla(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0) {
    let url = `/calleds/dashboard/montlysla?dateStart=${dateStart}&dateEnd=${dateEnd}&organizationId=${organizationId}&techinicalteamid=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`;
    await Api.get(url)
      .then(result => {
        if (result.data.success && result.data.data && result.data.data.length > 0) {
          const list = result.data.data;
          const totalCalleds = list.reduce((sum, item) => sum + (item.totalcalleds || 0), 0);
          const weighted = list.reduce((sum, item) => sum + ((item.calledslasolutionhitpercent || 0) * (item.totalcalleds || 0)), 0);
          this.setState({ slaPercent: totalCalleds > 0 ? Math.round(weighted / totalCalleds) : 0 });
        } else {
          this.setState({ slaPercent: 0 });
        }
      })
      .catch(err => this.notifyError(err));
  }

  async getCsat(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0) {
    let url = `/calledclassifications/chart/query?dateStart=${dateStart}&dateEnd=${dateEnd}&organizationId=${organizationId}&technicalteamid=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`;
    await Api.get(url)
      .then(result => {
        if (result.data.success) {
          this.setState({ csatData: result.data.data });
        }
      })
      .catch(err => this.notifyError(err));
  }

  async getNps(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0) {
    let url = `/calledclassifications/chart/query/nps?dateStart=${dateStart}&dateEnd=${dateEnd}&organizationId=${organizationId}&techinicalTeamId=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`;
    await Api.get(url)
      .then(result => {
        if (result.data.success) {
          this.setState({ npsData: result.data.data });
        }
      })
      .catch(err => this.notifyError(err));
  }

  async getFcr(dateStart, dateEnd, organizationId, technicalTeamId = 0, userId = 0, originRequestId = 0) {
    const result = await AgentProductivityService.getFcr(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId);
    if (result && result.success) {
      const total = result.data.numbertotal || 0;
      const inside = result.data.numbertotalinsidefcr || 0;
      this.setState({ fcrPercent: total > 0 ? Math.round((inside / total) * 100) : 0 });
    } else if (result) {
      this.notifyError(result);
    }
  }

  async getReopenedCount(dateStart, dateEnd, organizationId, technicalTeamId, userId, originRequestId = 0) {
    let url = `/report/reopenedcalleds/count?dateStart=${dateStart}&dateEnd=${dateEnd}&org=${organizationId}&status=0&techteam=${technicalTeamId}&userId=${userId}&originRequestId=${originRequestId}`;
    await ApiReports.get(url)
      .then(result => {
        if (result.data.success) {
          this.setState({ reopenedCount: result.data.data || 0 });
        }
      })
      .catch(err => this.notifyError(err));
  }

  async changeValues(stateName, value) {
    if (stateName === "technicalTeam") {
      this.setState({ technicalTeam: value, organization: { ...defaultFilterValue }, user: { ...defaultFilterValue } });
      await this.getOrganizations(value && value.id);
    } else if (stateName === "organization") {
      this.setState({ organization: value, user: { ...defaultFilterValue } });
    } else if (stateName === "user") {
      this.setState({ user: value });
      // Limpar o Agente (botão "X") faz o SimpleAutoCompleteSearch zerar sua lista
      // interna de opções (ele só recebe a lista pré-carregada uma vez, na montagem
      // — ver comentário em getUsers()) — sem recarregar aqui, reabrir o combo depois
      // de limpar mostra "No options" até o usuário digitar de novo. Só recarrega
      // quando a seleção é limpa (não a cada seleção normal, pra não remontar à toa).
      if (!value || !value.id) {
        await this.getUsers(this.state.technicalTeam.id, this.state.organization.id);
      }
    } else if (stateName === "dateStart" || stateName === "dateEnd") {
      // O date picker dispara onChange a cada tecla digitada, inclusive com datas parciais/inválidas
      // enquanto o usuário ainda está digitando. Se deixarmos essa data inválida entrar no estado,
      // ela volta pro próprio picker via prop `currentDate` e o campo "reseta" sozinho, sem aviso.
      if (moment(value).isValid()) {
        this.setState({ [stateName]: value });
      }
    } else {
      this.setState({ [stateName]: value });
    }
  }

  async search() {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');
    const intl = this.props.intl;

    if (dateStart > dateEnd) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date", defaultMessage: "Data inicial não pode ser maior que a data final" })
      });
      return;
    }

    this.setState({ loading: true });
    await this.loadItems(
      this.state.technicalTeam && this.state.technicalTeam.id,
      this.state.organization && this.state.organization.id,
      this.state.user && this.state.user.id,
      this.state.originRequest && this.state.originRequest.id
    );
    this.setState({ loading: false });
  }

  async clearFilters() {
    this.setState({
      dateStart: new Date(),
      dateEnd: new Date(),
      technicalTeam: { ...defaultFilterValue },
      organization: { ...defaultFilterValue },
      user: { ...defaultFilterValue },
      originRequest: { ...defaultFilterValue }
    });
    await this.getOrganizations(0);
    await this.search();
  }

  async componentDidMount() {
    await this.getAllSelectionModel();
    await this.getOriginRequests();
    await this.search();
  }

  async getPdf() {
    // Guarda contra clique duplo: se já tem uma exportação em andamento, ignora o novo clique
    // em vez de disparar um segundo html2canvas/jsPDF concorrente.
    if (this.state.loading) return;

    this.setState({ loading: true });
    try {
      const content = document.getElementById('agent-productivity-dashboard-content');
      if (content != null) {
        const canvas = await html2canvas(content);
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);
        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
        pdf.save('dashboard-produtividade-agente.pdf');
      }
    } catch (err) {
      // Sem isso, uma falha no html2canvas/jsPDF (imagem CORS-taintada, fonte ainda carregando, etc.)
      // interrompia a função antes do "loading: false" e prendia o indicador pra sempre.
      this.notifyError(err);
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const intl = this.props.intl;
    const colors = getChartColors();

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} style={{ minWidth: '300px' }} />
          <div id="agent-productivity-dashboard-content" style={{ paddingRight: 24, paddingLeft: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Grid container alignItems="center" spacing={1}>
                        <Grid item>
                          <span style={{ fontSize: 24, fontWeight: 700 }}>
                            <FormattedMessage id="agentproductivity.dashboard.title" defaultMessage="Dashboard de Produtividade do Agente" />
                          </span>
                        </Grid>
                        <Grid item>
                          <Tooltip title={intl.formatMessage({ id: 'refresh', defaultMessage: 'Atualizar' })}>
                            <span>
                              <IconButton size="small" color="secondary" onClick={this.search} disabled={this.state.loading}>
                                <RefreshIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      {this.state.showButtonPdf && (
                        <Button variant="contained" color="secondary" onClick={this.getPdf} disabled={this.state.loading}>
                          <FormattedMessage id="agentproductivity.dashboard.export" defaultMessage="Exportar" />
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleDatePicker
                    label={intl.formatMessage({ id: "start.date" })}
                    name="dateStart"
                    stateName="dateStart"
                    changeDate={this.changeValues}
                    currentDate={this.state.dateStart}
                    required />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleDatePicker
                    label={intl.formatMessage({ id: "end.date" })}
                    name="dateEnd"
                    stateName="dateEnd"
                    changeDate={this.changeValues}
                    currentDate={this.state.dateEnd}
                    required />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "productivity.dashboard.techinical.teams", defaultMessage: "Times de atendimento" })}
                    options={this.state.technicalTeamList}
                    stateName="technicalTeam"
                    changeSelect={this.changeValues}
                    selected={this.state.technicalTeam} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "productivity.dashboard.organizations", defaultMessage: "Organização" })}
                    options={this.state.organizationsList}
                    stateName="organization"
                    changeSelect={this.changeValues}
                    selected={this.state.organization} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "agentproductivity.dashboard.channel", defaultMessage: "Canal" })}
                    options={this.state.originRequestList}
                    stateName="originRequest"
                    changeSelect={this.changeValues}
                    selected={this.state.originRequest} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={2}>
                  <SimpleAutoCompleteSearch
                    key={this.state.userListVersion}
                    label={intl.formatMessage({ id: "agentproductivity.dashboard.agent", defaultMessage: "Agente" })}
                    options={this.state.userList}
                    stateName="user"
                    changeSelect={this.changeValues}
                    selected={this.state.user}
                    urlapi={Api.apiurlbase() + 'api/users/selectionmodel/search/2/' + this.state.technicalTeam.id + '/' + this.state.organization.id}
                    disabled={!(this.state.technicalTeam && this.state.technicalTeam.id > 0 && this.state.organization && this.state.organization.id > 0)} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={1} justifyContent="flex-end">
                <Grid item xs="auto">
                  <Button variant="contained" color="secondary" onClick={this.search}>
                    <FormattedMessage id="search" defaultMessage="Pesquisar" />
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <Button variant="outlined" color="secondary" onClick={this.clearFilters}>
                    <FormattedMessage id="agentproductivity.dashboard.clear" defaultMessage="Limpar" />
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <DashboardSkeleton loading={this.state.loading}>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.assigned', defaultMessage: 'Atribuídos' })}
                value={this.state.summary.totalassigned}
                subtitle={intl.formatMessage({ id: 'agentproductivity.dashboard.assigned.subtitle', defaultMessage: '100% do total' })}
                series={buildDailySeries(this.state.summary.assignedtrend)}
                icon={<AssignmentIndIcon />}
                accentColor={colors.info}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.resolved', defaultMessage: 'Resolvidos' })}
                value={this.state.summary.totalresolved}
                subtitle={intl.formatMessage(
                  { id: 'agentproductivity.dashboard.resolved.subtitle', defaultMessage: '{percent} dos atribuídos' },
                  { percent: formatPercent(this.state.summary.totalassigned > 0 ? (this.state.summary.totalresolved / this.state.summary.totalassigned) * 100 : 0, intl.locale) }
                )}
                series={buildDailySeries(this.state.summary.resolvedtrend)}
                icon={<TaskAltIcon />}
                accentColor={colors.primary}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.fcr', defaultMessage: 'FCR' })}
                value={`${this.state.fcrPercent}%`}
                subtitle={intl.formatMessage({ id: 'agentproductivity.dashboard.fcr.subtitle', defaultMessage: 'resolução no 1º contato' })}
                series={buildPercentSeries(this.state.summary.fcrtrend)}
                icon={<BoltIcon />}
                accentColor={colors.accentPurple}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.sla', defaultMessage: 'SLA cumprido' })}
                value={`${this.state.slaPercent}%`}
                subtitle={intl.formatMessage({ id: 'agentproductivity.dashboard.sla.subtitle', defaultMessage: 'dentro do prazo' })}
                series={buildPercentSeries(this.state.summary.slatrend)}
                icon={<VerifiedIcon />}
                accentColor={colors.warning}
                tooltip={intl.formatMessage({ id: 'agentproductivity.dashboard.sla.tooltip', defaultMessage: 'Percentual de chamados que cumpriram o SLA de solução dentro do prazo, no período selecionado.' })}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <KpiCard
                title={intl.formatMessage({ id: 'agentproductivity.dashboard.reopened', defaultMessage: 'Reabertos' })}
                value={this.state.reopenedCount}
                subtitle={intl.formatMessage(
                  { id: 'agentproductivity.dashboard.reopened.subtitle', defaultMessage: '{percent} dos resolvidos' },
                  { percent: formatPercent(this.state.summary.totalresolved > 0 ? (this.state.reopenedCount / this.state.summary.totalresolved) * 100 : 0, intl.locale) }
                )}
                series={buildDailySeries(this.state.summary.reopenedtrend)}
                icon={<ReplayIcon />}
                accentColor={colors.error}
              />
            </Grid>

            <Grid item xs={12} md={7}>
              <TicketsByAgent data={this.state.byAgent} />
            </Grid>
            <Grid item xs={12} md={5}>
              <ChannelDonut data={this.state.byChannel} />
            </Grid>

            <Grid item xs={12} md={6}>
              <CsatTable data={this.state.csatData} />
            </Grid>
            <Grid item xs={12} md={6}>
              <NpsTable data={this.state.npsData} />
            </Grid>

            <Grid item xs={12} md={4}>
              <PerformancePanel metrics={this.state.performanceMetrics} />
            </Grid>
            <Grid item xs={12} md={8}>
              <HourlyProductivityChart data={this.state.hourly} />
            </Grid>
            </DashboardSkeleton>
          </Grid>
          </div>

          <CustomizedSnackbars
            variant={this.state.notificationVariant}
            message={this.state.notificationMessage}
            isOpen={this.state.openNotification}
            toClose={this.closeNotification} />
        </main>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chatHubConnection: state.chatHubConnection,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AgentProductivityDashboard)));
